import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-terms-content',
  standalone: true,
  imports: [],
  templateUrl: './terms-content.component.html',
  styleUrl: './terms-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsContentComponent {}
